// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as ShoppingRouteImport } from './routes/shopping'
import { Route as RecipesRouteImport } from './routes/recipes'
import { Route as LoginRouteImport } from './routes/login'
import { Route as KitchenRouteImport } from './routes/kitchen'
import { Route as AppRouteImport } from './routes/app'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as JoinTokenRouteImport } from './routes/join.$token'
import { Route as SignupVerifyEmailAddressRouteImport } from './routes/signup.verify-email-address'
import { Route as RecipesIndexRouteImport } from './routes/recipes.index'
import { Route as RecipesRecipeIdRouteImport } from './routes/recipes.$recipeId'
import { Route as AdminImportMetricsRouteImport } from './routes/admin.import-metrics'
import { Route as AdminForbiddenRouteImport } from './routes/admin.forbidden'
import { Route as RecipesRecipeIdIndexRouteImport } from './routes/recipes.$recipeId.index'
import { Route as RecipesRecipeIdEditRouteImport } from './routes/recipes.$recipeId.edit'

const SignupRoute = SignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => rootRouteImport
          })
const SignUpRoute = SignUpRouteImport.update({
            id: '/sign-up',path: '/sign-up',getParentRoute: () => rootRouteImport
          })
const ShoppingRoute = ShoppingRouteImport.update({
            id: '/shopping',path: '/shopping',getParentRoute: () => rootRouteImport
          })
const RecipesRoute = RecipesRouteImport.update({
            id: '/recipes',path: '/recipes',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const KitchenRoute = KitchenRouteImport.update({
            id: '/kitchen',path: '/kitchen',getParentRoute: () => rootRouteImport
          })
const AppRoute = AppRouteImport.update({
            id: '/app',path: '/app',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const JoinTokenRoute = JoinTokenRouteImport.update({
            id: '/join/$token',path: '/join/$token',getParentRoute: () => rootRouteImport
          })
const SignupVerifyEmailAddressRoute = SignupVerifyEmailAddressRouteImport.update({
            id: '/verify-email-address',path: '/verify-email-address',getParentRoute: () => SignupRoute
          })
const RecipesIndexRoute = RecipesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => RecipesRoute
          })
const RecipesRecipeIdRoute = RecipesRecipeIdRouteImport.update({
            id: '/$recipeId',path: '/$recipeId',getParentRoute: () => RecipesRoute
          })
const AdminImportMetricsRoute = AdminImportMetricsRouteImport.update({
            id: '/import-metrics',path: '/import-metrics',getParentRoute: () => AdminRoute
          })
const AdminForbiddenRoute = AdminForbiddenRouteImport.update({
            id: '/forbidden',path: '/forbidden',getParentRoute: () => AdminRoute
          })
const RecipesRecipeIdIndexRoute = RecipesRecipeIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => RecipesRecipeIdRoute
          })
const RecipesRecipeIdEditRoute = RecipesRecipeIdEditRouteImport.update({
            id: '/edit',path: '/edit',getParentRoute: () => RecipesRecipeIdRoute
          })





const AdminRouteChildren = {
  AdminForbiddenRoute: AdminForbiddenRoute,AdminImportMetricsRoute: AdminImportMetricsRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const RecipesRecipeIdRouteChildren = {
  RecipesRecipeIdEditRoute: RecipesRecipeIdEditRoute,RecipesRecipeIdIndexRoute: RecipesRecipeIdIndexRoute
}

const RecipesRecipeIdRouteWithChildren = RecipesRecipeIdRoute._addFileChildren(RecipesRecipeIdRouteChildren)



const RecipesRouteChildren = {
  RecipesRecipeIdRoute: RecipesRecipeIdRouteWithChildren,RecipesIndexRoute: RecipesIndexRoute
}

const RecipesRouteWithChildren = RecipesRoute._addFileChildren(RecipesRouteChildren)




const SignupRouteChildren = {
  SignupVerifyEmailAddressRoute: SignupVerifyEmailAddressRoute
}

const SignupRouteWithChildren = SignupRoute._addFileChildren(SignupRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AdminRoute: AdminRouteWithChildren,AppRoute: AppRoute,KitchenRoute: KitchenRoute,LoginRoute: LoginRoute,RecipesRoute: RecipesRouteWithChildren,ShoppingRoute: ShoppingRoute,SignUpRoute: SignUpRoute,SignupRoute: SignupRouteWithChildren,JoinTokenRoute: JoinTokenRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)